import axios from "axios";

export const getCet = (cep: string) =>
  axios.get(`https://viacep.com.br/ws/${cep}/json/`);
